import styled from "styled-components";

const ModalBody = styled.div`
	margin-top: 19px;

	@media (max-width: 700px) {
		max-height: 400px;
		padding: 5px;
		overflow: auto;
	}
`;

export { ModalBody };
